module.exports = __webpack_public_path__ + "img/norberto_trillo.7eaf840f.png";